// ** React Imports
import { useEffect } from 'react'
import { isUserLoggedIn, getUserData, getHearderAuth, postMessageToOpener } from '@utils'
// ** Store Imports
import { handleSkin } from '@store/layout'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";
import * as Constants from '../../constants'
import querystring from 'querystring';
import axios from 'axios'

import Cookies from 'universal-cookie'

export const useSkin = () => {
  // ** Hooks
  const dispatch = useDispatch()
  const store = useSelector(state => state.layout)

  const setSkin = type => {
    dispatch(handleSkin(type))
  }

  useEffect(() => {
    const cookies = new Cookies()
    const dataCookie = cookies.get('sl_email_connect')
    if (dataCookie) {
      sessionStorage.setItem("tmp_email", dataCookie)
      cookies.remove('sl_email_connect');
    }

    // ** Get Body Tag
    const element = window.document.body

    // ** Define classnames for skins
    const classNames = {
      dark: 'dark-layout',
      bordered: 'bordered-layout',
      'semi-dark': 'semi-dark-layout'
    }

    // ** Remove all classes from Body on mount
    element.classList.remove(...element.classList)

    // ** If skin is not light add skin class
    if (store.skin !== 'light') {
      element.classList.add(classNames[store.skin])
    }

    const urlParams = new URLSearchParams(window.location.search);
    const logoutParam = urlParams.get('logout');
    if (logoutParam) {
      localStorage.clear()
    }
    const companyParam = urlParams.get('company');
    if (companyParam) {
      const date = new Date();
      date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `company=${companyParam};${expires};path=/`;
    }

    let current_token = ''
    if (isUserLoggedIn) {
      if (getUserData()?.data?.token) {
        current_token = getUserData().data.token
      } else {
        localStorage.clear()
      }
    }

    const website_url = window.location.href
    if (location.hash === '#popup') {
      element.classList.add('popup-wp')
      const url_param = new URL(website_url)
      const company = url_param.searchParams.get("company")
      if (company) {
        sessionStorage.setItem('company', company)
        sessionStorage.setItem('show_logo', 0)
      }
      const agent = url_param.searchParams.get("agent")
      if (agent) {
        sessionStorage.setItem('agent_df', agent)
      }
      if (sessionStorage.getItem('curr_url') !== website_url) {
        try {
          const tokenws = url_param.searchParams.get("tokenws")
          if (tokenws) {
            if (tokenws !== current_token) {
              sessionStorage.setItem('curr_url', website_url)
              location.href = `${location.origin}/misc/not-authorized`
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    } else {
      const url_param = new URL(website_url)
      const tokenws = url_param.searchParams.get("tokenws")
      if (tokenws) {
        const return_url2 = website_url.split('?')
        if (return_url2.length == 2) {
          if (website_url.indexOf('/apps/settings/billing/2') > 0) {
            sessionStorage.setItem('mess_off_request', 'ok')
          } else if (website_url.indexOf('/apps/settings/billing') > 0) {
            sessionStorage.setItem('mess_bill', 'ok')
          }
          if (tokenws !== current_token) {
            sessionStorage.setItem('ch_url_aflg', return_url2[0])
            sessionStorage.setItem('curr_url', website_url)
            location.href = `${location.origin}/misc/not-authorized`
          }
          if (website_url.indexOf('/email/app-token') > 0) {
            url_param.searchParams.delete("tokenws")
            sessionStorage.setItem('ch_url_aflg', url_param.toString())
          }
        }
      }
      const hideParam = url_param.searchParams.get("hide")
      if (hideParam && hideParam === 'menu') {
        element.classList.add('hide-left-menu')
      }
    }

    if (sessionStorage.getItem('curr_url')) {
      const url_param = new URL(sessionStorage.getItem('curr_url'))
      try {
        const tokenws = url_param.searchParams.get("tokenws")
        const df_company = url_param.searchParams.get("company")
        const config = {
          method: 'get',
          url: `${Constants.REST_API_WORKSUITE_V3}accounts/details`,
          headers: {
            Authorization: `Bearer ${tokenws}`
          }
        }
        axios(config)
          .then(function (response) {
            const curr_user = response.data?.data
            if (curr_user) {
              const userData = {
                ability: [
                  {
                    action: "read",
                    subject: "ACL"
                  },
                  {
                    action: "read",
                    subject: "Auth"
                  }
                ],
                avatar: curr_user.image_url,
                email: curr_user.email,
                fullName: curr_user.name,
                id: curr_user.id,
                jwt: tokenws,
                // data: [],
                role: '',
                username: curr_user.email
              }
              userData.data = {
                token: tokenws,
                user: curr_user
              }
              localStorage.setItem('userData', JSON.stringify(userData))
              // sessionStorage.removeItem("curr_url")

              let config2 = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${Constants.REST_API_WORKSUITE_V3}companies`,
                headers: {
                  Authorization: `Bearer ${tokenws}`
                }
              };

              axios.request(config2)
                .then((res) => {
                  if (res.data.data.length > 0) {
                    let defaultCompany = res.data.data[0];
                    res.data.data.forEach((item) => {
                      if ((Constants?.DASHBOARD_DOMAIN[location.hostname] && Constants?.DASHBOARD_DOMAIN[location.hostname]?.id == item.id) || (df_company && df_company == item.id)) {
                        defaultCompany = item;
                      }
                    });
                    localStorage.setItem("token_company", defaultCompany.x_token);
                    localStorage.setItem("company", JSON.stringify(defaultCompany));

                    // get user role
                    axios.request({
                      method: "get",
                      url: `${Constants.REST_API_WORKSUITE_V3}accounts/role-users`,
                      headers: {
                        Authorization: `Bearer ${tokenws}`,
                        "X-WorkSuite-Company-Token": defaultCompany.x_token,
                      },
                    }).then((res) => {
                      if (res.data?.data?.[0]?.name) {
                        localStorage.setItem("last_role_use_login", res.data?.data?.[0]?.name);
                      } else {
                        const formData = new FormData();
                        formData.append('x_token', defaultCompany.x_token);
                        formData.append('email', curr_user.email);

                        axios.post(`${Constants.API_CLOODO}fix-role-client`, formData)
                          .then((roleRes) => {
                            if (roleRes.data?.role_name) {
                              localStorage.setItem("last_role_use_login", roleRes.data.role_name);
                            }
                          })
                          .catch((error) => {
                            console.log('Error fixing role:', error);
                          });
                      }

                      let return_url = `${location.origin}/apps/message#popup`
                      if (sessionStorage.getItem('curr_url')) {
                        return_url = sessionStorage.getItem('curr_url')
                        sessionStorage.removeItem("ch_url_aflg")
                        sessionStorage.removeItem("curr_url")
                      }
                      localStorage.removeItem('contact_data');
                      localStorage.removeItem('chat_data');
                      location.href = return_url
                      return;
                    })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              if (sessionStorage.getItem('visited')) {
                sessionStorage.removeItem("curr_url");
              } else {
                sessionStorage.setItem('visited', true);
              }
              // location.reload()
            }
          })
          .catch(function (error) {
            console.log(error)
            toast.error("Your session has expired, please login again")
            setTimeout(() => {
              sessionStorage.clear();
              window.location.href = "/login";
            }, 5000);
          })
      } catch (error) {
        console.log(error)
      }
    }

    if (isUserLoggedIn) {
      try {
        const cookies = new Cookies();
        const companyCookie = cookies.get('company');
        const data_user = getUserData()
        const token_company = localStorage?.getItem("token_company");

        // Kiểm tra cookie company và chưa có token_company
        if (companyCookie && !token_company && data_user) {
          let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${Constants.REST_API_WORKSUITE_V3}companies`,
            headers: {
              Authorization: `Bearer ${data_user?.data?.token}`
            }
          };

          axios.request(config)
            .then((res) => {
              if (res.data.data.length > 0) {
                let defaultCompany = res.data.data[0];
                // Tìm company match với cookie
                res.data.data.forEach((item) => {
                  if (item.id.toString() === companyCookie) {
                    defaultCompany = item;
                  }
                });

                // Lưu thông tin company
                localStorage.setItem("token_company", defaultCompany.x_token);
                localStorage.setItem("company", JSON.stringify(defaultCompany));

                // Lấy role user
                axios.request({
                  method: "get",
                  url: `${Constants.REST_API_WORKSUITE_V3}accounts/role-users`,
                  headers: {
                    Authorization: `Bearer ${data_user?.data?.token}`,
                    "X-WorkSuite-Company-Token": defaultCompany.x_token,
                  },
                }).then((roleRes) => {
                  if (roleRes.data?.data?.[0]?.name) {
                    localStorage.setItem("last_role_use_login", roleRes.data?.data?.[0]?.name);
                  } else {
                    const formData = new FormData();
                    formData.append('x_token', defaultCompany.x_token);
                    formData.append('email', data_user.email);

                    axios.post(`${Constants.API_CLOODO}fix-role-client`, formData)
                      .then((fixRoleRes) => {
                        if (fixRoleRes.data?.role_name) {
                          localStorage.setItem("last_role_use_login", fixRoleRes.data.role_name);
                        }
                      })
                      .catch((error) => {
                        console.log('Error fixing role:', error);
                      });
                  }
                }).catch((error) => {
                  console.log('Error getting user role:', error);
                });
              }
            })
            .catch((error) => {
              console.log('Error getting companies:', error);
            });
        }

        // Code xử lý drive và các chức năng khác
        if (!data_user.data.drive && token_company) {
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://convert.cloodo.com/synch-drive',
            headers: getHearderAuth()
          };

          axios.request(config)
            .then((response) => {
              if (response.data) {
                const token_drive = response.data.token
                if (token_drive) {
                  data_user.data.drive = token_drive
                }
                const color_df = response.data.color
                if (color_df) {
                  localStorage.setItem("color_ms", color_df)
                }
                localStorage.setItem('userData', JSON.stringify(data_user))
              }
            })
            .catch((error) => {
              console.log(error);
            });

          let data_m = new FormData();
          data_m.append('type', 'map_uid');
          let config_m = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${Constants.REST_API_WORKSUITE_V3}messages/map-infor`,
            headers: getHearderAuth(),
            data: data_m
          };

          axios.request(config_m)
            .then((response) => {
              // console.log(JSON.stringify(response.data));
              if (response.data) {
                const idString = response.data.id.toString();
                data_user.iuds = Buffer.from(idString).toString('base64');
                localStorage.setItem('userData', JSON.stringify(data_user))
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }

        if (!data_user.data.jwt) {
          const data = {
            token: getUserData()?.data?.token,
          };
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${Constants.REST_API}/users-permissions/user/token`,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          };
          axios(config)
            .then(response => {
              // console.log(response.data);
              if (response.data?.jwt) {
                data_user.data.jwt = response.data.jwt;
                postMessageToOpener(data_user);
              }
              localStorage.setItem('userData', JSON.stringify(data_user));
            })
            .catch(error => {
              console.log(error.response, error.response.status);
              if (error.response && error.response.status === 404) {
                data_user.data.jwt = 'user_not_found';
                localStorage.setItem('userData', JSON.stringify(data_user));
              } else {
                console.error(error);
              }
            });
        } else {
          postMessageToOpener(data_user);
        }

        if (localStorage.getItem("last_role_use_login") === "undefined" && token_company) {
          const formData = new FormData();
          formData.append('x_token', token_company);
          formData.append('email', data_user.email);

          axios.post(`${Constants.API_CLOODO}fix-role-client`, formData)
            .then((roleRes) => {
              if (roleRes.data?.role_name) {
                localStorage.setItem("last_role_use_login", roleRes.data.role_name);
              }
            })
            .catch((error) => {
              console.log('Error fixing role:', error);
            });
        }
      } catch (error) {
        console.log(error)
      }
    }
  }, [store.skin])

  return { skin: store.skin, setSkin }
}
